<script>
import { get } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default {
  mixins: [fandomBasicMixin],
  props: {
    entered: Boolean
  },
  mounted() {
    Vue.nextTick(() => {
      disableBodyScroll(this.$el);
    });
  },
  beforeDestroy() {
    clearAllBodyScrollLocks();
  },
  data: function() {
    return {
      searchText: ""
    };
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
    search() {
      window.location.href = `${this.resultUrl}?filters=${encodeURI(JSON.stringify({"searchText":this.searchText}))}`;
    }
  },
  computed: {
    resultUrl() {
      return get(this.content, ['search_result_url','url'], "search");
    }
  },
};
</script>

<template>
  <div class="h-100vh w-100 w-limiter" search-fullscreen-component>
    <!-- this div is just a pleceholder for the nav -->
    <div class="p-4 w-100 d-flex flex-column">
      <div class="p3"></div>
    </div>
    <!-- end placeholder -->
    <div class="search-content mx-0">
      <transition enter-active-class="animated faster fadeInRight" leave-active-class="animated faster fadeOutRight d-01" v-on:after-leave="toggle()">
        <div v-if="entered" class="search-field col-12 col-md-4 col-lg-3 mt-0 mt-md-5 d-flex flex-column flex-md-row mb-5">
          <div class="search-icon mr-5 cursor-pointer d-flex flex-column justify-content-center">
            <i class="far fa-search"></i>
          </div>
          <input type="search"  v-on:keyup.esc="close()" class="custom-input" v-model="searchText" :placeholder="ft('globals.search_in_farm')" id="search-input" v-on:keyup.enter="search()">
        </div>
      </transition>
      <transition enter-active-class="animated faster fadeInRight d-01" leave-active-class="animated faster fadeOutRight">
        <div 
          class="quick-links col-12 col-md-4 col-lg-3 mt-0 mt-md-5 d-flex flex-column mb-5 pb-3"
          v-if="entered && content.quick_links"
        >
          <span class="quick-links-header font-weight-bold text-uppercase my-3">{{ft("globals.quick_links")}}</span>
          <a 
            v-for="link in content.quick_links"
            :href="link.url.url"
            :target="getTarget(link.url)"
            class="quick-link"
          >
            {{link.url.title}}
          </a>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss">
[search-fullscreen-component] {
  background-color: $white;
  color: inherit;
  position: fixed;
  top: 0;
  overflow-y: auto;

  @media (min-width: 1920px) {
    left: calc((100vw - 1920px)/2);
  }
  @media (max-width: 1919px) {
    left: 0;
  }

  .faster {
    animation-duration: $animation-time-fast;
  }

  .d-01 {
    animation-delay: $animation-time-fast;
  }

  .search-content {
    padding: 0 10%;
  }

  .custom-input {
    height: 2.5em;
    margin-left: 0;
    padding: 0;
    font-size: 1.875rem;
    line-height: 2.5em;
    letter-spacing: 1px;
    font-style: italic;
    font-weight: 100;
    color: inherit;
    background-color: transparent;
    border: 0;
    outline-width: 0px;

    &::placeholder {
      color: inherit;
    }
  }

  .search-icon {
    font-size: 2rem;
  }

  .quick-links-header {
    font-size: $font-size-xs;
  }
  
  .quick-link {
    font-size: .75rem;
    color: inherit;
    transition: color .25s;
    text-decoration: none;
    line-height: 1.375rem;

    &:hover {
      color: $primary;
    }
  } 
}
</style>
